// extracted by mini-css-extract-plugin
export var banner = "_o9-0";
export var settingRow = "_o9-2";
export var titleIcon = "_o9-1";